export const BASE_URL = process.env.REACT_APP_API_URL || `https://test.appraiser-assistant.com/api`;

// 1 Car Information by Vin Number API
export const API_URL_CAR_INFO_BY_VIN_NUMBER = `/car/carinfoByVin`;
export const API_URL_CAR_INFO_VIN = `/car/carInfo`;
export const API_URL_MARKET_VALUE_PRICE = `/car/marketValuebyVin`;
// api:- http://192.168.1.37:5000/api/car/carinfoByVin/5TDYK3DC8FS560664

// 2 Car Listing API
export const API_URL_CAR_LISTING = `/car/carListing`;
// api:- http://192.168.1.64:5000/api/car/carListing?year_max=2020&price_max=60000

// 3 Sale History API
export const API_URL_SALE_HISTORY = `/car/saleHistory`;
// api:- http://192.168.1.56:5000/api/car/saleHistory/5TDYK3DC8FS560664

// 4 Auction API
export const API_URL_AUCTION = `/car/auction`;
// api:- http://localhost:5000/api/car/auction/5TDYK3DC8FS560664

export const API_URL_MAKE = "/car/makes";
// api:- http://localhost:5000/api/car/auction/5TDYK3DC8FS560664

export const API_URL_MODEL = "car/models";
// api:- http://localhost:5000/api/car/auction/5TDYK3DC8FS560664

// 5. Market value on the basis of Year, car model
export const API_URL_MARKET_VALUE = `/car/marketValuebyYearAndModel`;
// api:- http://localhost:5000/api/car/marketValuebyYearAndModel?year=2022&make=Tesla&model=Model 3&state=2022&mileage_value=12000

// 6. Get Cars by body style, price or year
export const API_URL_BODY_TYPE_FILTERATION = `/car/bodyTypeFilteration`;
// api:- http://192.168.1.64:5000/api/car/bodyTypeFilteration/suv
export const API_URL_PRICE_FILTERATION = `/car/priceFilteration`;
// api:- http://192.168.1.64:5000/api/car/priceFilteration/page
export const API_URL_YEAR_FILTERATION = `/car/yearFilteration`;
// api:- http://192.168.1.64:5000/api/car/yearFilteration/page

export const API_URL_PREMIUM_VIN_DECODE = `/premiumVinDecode`;
export const API_URL_GENERATE_PDF = `/car/generatePdf`;
export const API_URL_Compare_GENERATE_PDF = `/car/generateFreetrialPdf`;
export const API_URL_SIGNIN = `/user/login`;
export const API_URL_SIGNUP = `/user/register`;
export const API_SALVAGE_LIST = `/car/salvagevaluecarlistings`;
export const API_SALVAGE_PDF = `/car/finalSalvageReeport`;
export const API_GENERATE_PDF = `/car/finalSalvageReeportNewVersion`;
export const API_DEFAULT_FILTER_VALUES = `/car/defaultValues`;

// Stripe/Subscription APIs
export const API_STRIPE_PRODUCTS = `/stripe/products`;
export const API_STRIPE_CREATE_CHECKOUT = `/stripe/create-checkout-session`;
export const API_STRIPE_SUBSCRIPTION_STATUS = `/stripe/subscription-status`;
export const API_STRIPE_CREATE_PORTAL = `/stripe/create-portal-session`;
export const API_STRIPE_REDEEM_CODE = `/stripe/redeem-code`;
export const API_STRIPE_VALIDATE_CODE = `/stripe/validate-code`;

// Google Auth
export const API_AUTH_GOOGLE = `/auth/google`;

// User Profile
export const API_USER_PROFILE = `/user/profile`;

// Admin Bulk Subscription APIs (now also used by managers)
export const API_BULK_SUBSCRIPTION_CREATE_CHECKOUT = `/admin/bulk-subscriptions/create-checkout-session`;
export const API_BULK_SUBSCRIPTION_PURCHASES = `/admin/bulk-subscriptions/purchases`;
export const API_BULK_SUBSCRIPTION_PURCHASE_CODES = `/admin/bulk-subscriptions/purchases`; // :purchaseId/codes
export const API_BULK_SUBSCRIPTION_REVOKE_CODE = `/admin/bulk-subscriptions/codes`; // :codeId/revoke
export const API_BULK_SUBSCRIPTION_STATS = `/admin/bulk-subscriptions/stats`;
